import React from 'react';
import FullWidthBlocks from 'commonComponents/FullWidthBlocks/FullWidthBlocks';
import ServiceBox from '../ServiceBox/ServiceBox';

const Services = ({ boxes, coming, button }) => {
  const boxRender = (box, i) => {
    const boxProps = {
      ...box,
      button,
      index: i
    };

    return (
      <ServiceBox
        key={ box.title }
        { ...boxProps }
      />
    );
  };

  return (
    <FullWidthBlocks
      anchor='services'
      boxes={ boxes }
      lastBox={ coming }
      boxRender={ boxRender }
    />
  );
};
 
export default Services;
